import React from 'react';
import Const from 'constants';
import {Table as ClassicTable} from './classic';
import {Table as TiersTable} from './tiers';

const PlayersList = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicTable;
        } else if (sportConfig.isGameTypeShowDown()) {
            return ClassicTable;
        } else if (sportConfig.isGameTypeTiers()) {
            return TiersTable;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersList};
